// src/services/WebDev.jsx
import React from "react";
import Seo, { SITE } from "../components/Seo/Seo";
import HeroWebSection from "../components/WebDev/HeroWebSection";
import ProjectRequestSection from "../components/ProjectRequestSection/ProjectRequestSection";
import FAQSection from "../components/FAQSection/FAQSection";
import { webDevFAQs, webDevIntro } from "../data/WebDev/WebDevFAQ";
import ProjectSteps from "../components/ProjectSteps/ProjectSteps";
import WebDevSteps from "../data/WebDev/WebProjectSteps";
import WebExpertise from "../data/WebDev/WebExpertise";
import ServiceSection from "../components/ServiceSection/ServiceSection";
import webDevData from "../data/WebDev/WebDevServices";
import WebDevLogoSlider from "../data/WebDev/WebDevLogoSlider";
import RPASection from "../components/RPASection/RPASection";
import WebRpaData from "../data/WebDev/WebrpaData";

const serviceJsonLd = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Webentwicklung",
  serviceType: "Webentwicklung & Webdesign",
  description:
    "Professionelle Webentwicklung aus Köln: Business-Websites, Web-Anwendungen, CRM-Portale und E-Commerce-Lösungen.",
  provider: { "@id": `${SITE.url}/#organization` },
  areaServed: ["Köln", "Bonn", "Deutschland"],
  url: `${SITE.url}/services/web-development`,
};

const WebDev = () => {
  return (
    <>
      <Seo
        title="Webentwicklung & Webdesign Agentur Köln | Nexite IT"
        description="Professionelle Webentwicklung aus Köln: Wir erstellen performante Websites, Web-Apps und E-Commerce-Lösungen mit React, TypeScript und modernen CMS – DSGVO-konform und SEO-optimiert."
        path="/services/web-development"
        jsonLd={serviceJsonLd}
      />

      <HeroWebSection />
      <ServiceSection data={webDevData} />
      <WebExpertise />
      <ProjectRequestSection />
      <ProjectSteps title="Unser Prozessablauf" steps={WebDevSteps} />
      <WebDevLogoSlider />
      <RPASection data={WebRpaData} />
      <FAQSection faqs={webDevFAQs} intro={webDevIntro} />
      <ProjectRequestSection />
    </>
  );
};

export default WebDev;
